import React from "react";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

export default function DialogApuramentoHeader({
  tipo,
  id,
  nome,
  fabricante,
  periodo,
  setPeriodo,
  total,
  loading,
  onRecalcular,
}) {
  const formatarValor = (valor) =>
    Number(valor || 0).toLocaleString("pt-PT", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <MDBox
      p={{ xs: 1.5, md: 2 }}
      sx={{
        border: "1px solid #dcdcdc",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        maxWidth: "100%",
      }}
    >
      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          md: "110px minmax(220px, 1.5fr) 140px minmax(220px, 1fr)",
        }}
        columnGap={2}
        rowGap={1}
        alignItems="center"
      >
        <MDTypography variant="caption" color="text" fontWeight="bold">
          ID
        </MDTypography>

        <MDTypography variant="button" fontWeight="regular">
          {id || ""}
        </MDTypography>

        <MDTypography variant="caption" color="text" fontWeight="bold">
          Fabricante
        </MDTypography>

        <MDTypography variant="button" fontWeight="regular">
          {fabricante || "Não identificado"}
        </MDTypography>

        <MDTypography variant="caption" color="text" fontWeight="bold">
          {tipo || "Origem"}
        </MDTypography>

        <MDTypography
          variant="button"
          fontWeight="bold"
          sx={{
            gridColumn: { xs: "auto", md: "2 / span 3" },
          }}
        >
          {nome || ""}
        </MDTypography>
      </MDBox>

      <MDBox
        mt={2}
        pt={2}
        sx={{
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <MDBox
          display="grid"
          gridTemplateColumns={{
            xs: "1fr",
            sm: "1fr 1fr",
            lg: "190px 190px auto minmax(180px, 1fr)",
          }}
          gap={1.5}
          alignItems="center"
        >
          <MDInput
            label="Data inicial"
            type="date"
            value={periodo?.datainicial || ""}
            onChange={(e) =>
              setPeriodo((anterior) => ({
                ...anterior,
                datainicial: e.target.value,
              }))
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <MDInput
            label="Data final"
            type="date"
            value={periodo?.datafinal || ""}
            onChange={(e) =>
              setPeriodo((anterior) => ({
                ...anterior,
                datafinal: e.target.value,
              }))
            }
            InputLabelProps={{ shrink: true }}
            fullWidth
          />

          <MDButton
            color="info"
            onClick={onRecalcular}
            disabled={loading}
            sx={{
              width: { xs: "100%", sm: "auto" },
              whiteSpace: "nowrap",
            }}
          >
            Recalcular
          </MDButton>

          <MDBox
            display="flex"
            flexDirection="column"
            alignItems={{ xs: "flex-start", lg: "flex-end" }}
            justifyContent="center"
            sx={{
              minHeight: 48,
            }}
          >
            <MDTypography variant="caption" color="text">
              Total apurado
            </MDTypography>

            <MDTypography variant="h5" fontWeight="bold">
              {formatarValor(total)} €
            </MDTypography>
          </MDBox>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
